
export default {
  formActions: {
    addPlaceInput: 'Adicionar campo',
    clearRoute: 'Limpar rota',
    reverseRoute: 'Reverter rota',
    roundTrip: 'Rota circular',
    toggleRoundTrip: 'Alternar rota circular'
  }
}
